import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { SortObject } from '@/pages/menu-managements/services/searchItem';
import { Title } from '@/pages/menu-managements/services/title';
import { MenuManagementBrandMenuService } from '@/services/BrandMenu/MenuManagementBrandMenuService';

export type MenuManagementBrandMenuCreateParams = {
  associate_brand_id: number;
  title: Title;
  memo: string | null;
  brand_category_sort_objects: SortObject[];
};

export const useMenuManagementCreateBrandMenu = async (
  params: MenuManagementBrandMenuCreateParams
): Promise<void> => {
  const menuManagementBrandMenuService = new MenuManagementBrandMenuService(
    getClient()
  );

  return menuManagementBrandMenuService
    .create(params)
    .catch((error: Error) => errorHandler({ error }));
};
